const NINGUNO = 'N'
const BANCOS = 'B'
const DOCUMENTOS_VARIOS = 'D'
const CAJA = 'C'
const ACTIVO_FIJO = 'A'
const DEPRECIACION = 'E'
const OPCIONAL = 'P'

const __dictionary = {
  [NINGUNO]: {
    id: NINGUNO,
    nombre: 'NINGUNO'
  },
  [BANCOS]: {
    id: BANCOS,
    nombre: 'BANCOS'
  },
  [DOCUMENTOS_VARIOS]: {
    id: DOCUMENTOS_VARIOS,
    nombre: 'DOCUMENTO 12,16,42,46'
  },
  [CAJA]: {
    id: CAJA,
    nombre: 'CAJA'
  },
  [ACTIVO_FIJO]: {
    id: ACTIVO_FIJO,
    nombre: 'ACTIVO FIJO'
  },
  [DEPRECIACION]: {
    id: DEPRECIACION,
    nombre: 'DEPRECIACION'
  },
  [OPCIONAL]: {
    id: OPCIONAL,
    nombre: 'OPCIONAL'
  }
}

const __array = [
  __dictionary[NINGUNO],
  __dictionary[BANCOS],
  __dictionary[DOCUMENTOS_VARIOS],
  __dictionary[CAJA],
  __dictionary[ACTIVO_FIJO],
  __dictionary[DEPRECIACION],
  __dictionary[OPCIONAL]
]

const __values = [NINGUNO, BANCOS, DOCUMENTOS_VARIOS, CAJA, ACTIVO_FIJO, DEPRECIACION, OPCIONAL]

const __valuesOrigenDiario = [BANCOS, DOCUMENTOS_VARIOS, CAJA, ACTIVO_FIJO, DEPRECIACION]

export default Object.freeze({
  NINGUNO,
  BANCOS,
  DOCUMENTOS_VARIOS,
  CAJA,
  ACTIVO_FIJO,
  DEPRECIACION,
  OPCIONAL,
  __dictionary,
  __array,
  __values,
  __valuesOrigenDiario
})
